// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "5bf11b3c64a7ffe4f8d4" + ".js";
};